// SaveFailureNotice: the one listener for a failed save, whatever page made
// it (utils/saveFailureNotice.js explains why this exists). It hands the
// message to the one notice store, so it looks like every other notice.
import { useEffect } from 'react';
import { showNotice } from '../utils/notices';
import { SAVE_FAILED_EVENT } from '../utils/saveFailureNotice';

export default function SaveFailureNotice() {
  useEffect(() => {
    const onFailed = (e) => {
      const { title, message, kind } = e.detail || {};
      showNotice({
        kind: kind || 'error',
        title: title || 'Your change was not saved',
        detail: message || 'Check your connection and try again.',
      });
    };
    window.addEventListener(SAVE_FAILED_EVENT, onFailed);
    return () => window.removeEventListener(SAVE_FAILED_EVENT, onFailed);
  }, []);
  return null;
}
